import {useNavigate, useSearchParams} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import {GateContext} from "../../tools/contexts/GateContext";
import LoadingScreen from "../LoadingScreen";
import servicesRoute from "../../tools/servicesRoute";

const DivarInternalCarGate = () => {
    const navigate = useNavigate();

    const {
        id,
        serviceType,
        postToken,
        returnUrl,
        loading,
        handleLoading,
        handleGetPlatformLink,
        code,
        ticketUuid,
        handlePlatformGuard
    } = useContext(GateContext);

    useEffect(() => {
        if (code) {
            const params = {
                "service_type": serviceType,
                "platform_hash_id": id,
                "post_token": sessionStorage.getItem('ticket_uuid') + "|" + sessionStorage.getItem('post_token'),
                "code": code
            }
            handlePlatformGuard(params,(data)=>{
                sessionStorage.setItem('token', data.access_token);
                sessionStorage.setItem('platform', data.client_name);
                sessionStorage.setItem('platformUser', JSON.stringify(data.platform_user));
                sessionStorage.setItem('service_type', serviceType);
                navigate(servicesRoute[serviceType].path, {
                    state: {
                        access_token: data.access_token,
                        platform: data.client_name,
                        platform_user: data.platform_user,
                        mobile: data.platform_user.phone_number,
                        defaultService: serviceType,
                    }, replace: true
                })
            });
        } else {
            handlePlatformLink()
        }
    }, []);
    const handlePlatformLink = () => {
        localStorage.clear();
        sessionStorage.clear();
        if (id) {
            sessionStorage.setItem('id', id)
        }
        if (ticketUuid) {
            sessionStorage.setItem('ticket_uuid', ticketUuid)
        }
        if (returnUrl) {
            sessionStorage.setItem('return_url', returnUrl)
        }
        if (postToken) {
            sessionStorage.setItem('post_token', postToken)
        }
        const params = {
            "service_type": serviceType,
            "platform_hash_id": id,
            "post_token": ticketUuid+'|'+postToken,
        }
        handleLoading(true)
        handleGetPlatformLink(params);
    }
    if (loading) {
        return <LoadingScreen/>
    }
    return <></>
}
export default DivarInternalCarGate;